import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class TrackProgress extends Component {
  static defaultProps = {
    'time': 32,
    'length': 302,
  }

  getProgress() {
    return (this.props.time / this.props.length) * 100;
  }

  getTimeString(time) {
    function pad(num) {
      return ("0"+num).slice(-2);
    }

    let seconds = pad(Math.floor(time % 60));
    let minutes = Math.floor(time / 60);

    if(!time || typeof time !== "number") {
      minutes = '00';
      seconds = '00';
    }

    return `${minutes}:${seconds}`;
  }

  _seek(e) {
    let domElement = this.progress.getBoundingClientRect();
    let percentage = ((e.pageX - domElement.left) / domElement.width) * 100;
    let seekValue = (this.props.length / 100) * percentage;

    this.props.handler(seekValue);
  }

  render() {
    const dynamic_styles = StyleSheet.create({
      progress: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: (Theme.player.progress.width / 100) * this.getProgress(),
        height: Theme.player.progress.thickness,
        backgroundColor: Theme.player.progress.played_color,
        transition: 'all 100ms ease-in-out',
      }
    });

    const length = this.getTimeString(this.props.length);

    return (
      <div className={css(styles.container)}>
        <div className={css(styles.text, styles.duration)}>{this.getTimeString(this.props.time)}</div>
        <div
          className={css(styles.progress_container)}
          onMouseDown={this._seek.bind(this)}
          ref={(ref) => (this.progress = ref)} >
          <div className={css(dynamic_styles.progress)} />
        </div>
        <div className={css(styles.text, styles.length)}>
          {length !== "00:00" ? length : false}
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    marginLeft: 20,
    marginRight: 20,
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontFamily: Theme.fontFamily_secondary,
    fontWeight: 500,
    color: Theme.black,
    fontSize: 11,
    letterSpacing: 1,
    marginLeft: 15,
    marginRight: 15,
  },
  duration: {
    width: 30,
  },
  length: {
    width: 30,
  },
  progress_container: {
    position: 'relative',
    cursor: 'pointer',
    width: Theme.player.progress.width,
    height: Theme.player.progress.thickness,
    backgroundColor: Theme.player.progress.color,
  },
});



// WEBPACK FOOTER //
// ./src/components/TrackProgress/index.js